
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { formatDistanceToNow, format } from 'date-fns';
import { useLocation } from 'react-router-dom';
import { FaFileAlt, FaImage, FaPhone, FaPoll } from 'react-icons/fa';

const MessagePanel = () => {
    const [contacts, setContacts] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [showOptions, setShowOptions] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const state = location.state;
        if (state?.contact) {
            setSelectedContact(state.contact);
            const contactMessages = contacts.filter(item => item.waid === state.contact.waid).map(item => ({
                sender: item.sentMessage ? 'You' : 'Customer',
                text: item.receivedMessage || item.sentMessage || '',
                received_date: item.received_date,
            }));
            setMessages(contactMessages);
        } else if (state?.messageData) {
            setMessages([{
                sender: 'Customer',
                text: state.messageData.receivedMessage,
                received_date: state.messageData.received_date,
            }]);
        }
    }, [location.state, contacts]);

    // useEffect(() => {
    //     axios.get('htttp://localhost:4000/pages/api/api/webhook-data')
    //         .then((response) => {
    //             setContacts(response.data);
    //             if (response.data.length > 0) {
    //                 setSelectedContact(response.data[0]);
    //             }
    //         })
    //         .catch((err) => {
    //             console.error('Error fetching data:', err);
    //         });
    // }, []);

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const webhookTable = user?.webhook_table;

        if (!webhookTable) return;

        axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
            webhook_table: webhookTable
        })
            .then((response) => {
                setContacts(response.data);
                const state = location.state;
                if (state?.contact) {
                    setSelectedContact(state.contact);
                    const contactMessages = response.data.filter(item => item.waid === state.contact.waid).map(item => ({
                        sender: item.sentMessage ? 'You' : 'Customer',
                        text: item.receivedMessage || item.sentMessage || '',
                        received_date: item.received_date,
                    }));
                    setMessages(contactMessages);
                } else if (state?.messageData) {
                    setMessages([{
                        sender: 'Customer',
                        text: state.messageData.receivedMessage,
                        received_date: state.messageData.received_date,
                    }]);
                }
            })
            .catch((err) => {
                console.error('Error fetching data:', err);
            });
    }, [location.state]);


    const handleSelectContact = (contact) => {
        setSelectedContact(contact);
        const contactMessages = contacts.filter(item => item.waid === contact.waid)
            .map(item => ({
                sender: item.sentMessage ? 'You' : 'Customer',
                text: item.receivedMessage || item.sentMessage || '',
                received_date: item.received_date,
            }));
        setMessages(contactMessages);
    };

    const handleSendMessage = () => {
        const user = JSON.parse(sessionStorage.getItem('user'));
        if (newMessage.trim()) {
            setMessages([...messages, { sender: 'You', text: newMessage }]);

            const payload = {
                id: user?.wa_id || "",
                mobile: selectedContact?.waid,
                message: newMessage,
            };
            axios.post('https://emedha.com/echatbot/enotifier/client-message.php', payload)
                .then(response => {
                    console.log('Message sent successfully', response);
                })
                .catch(error => {
                    console.error('Error sending message:', error);
                });
            setNewMessage('');
        }
    };

    // const handleSendMessage rv = () => {
    //     if (newMessage.trim()) {
    //         setMessages([...messages, { sender: 'You', text: newMessage }]);
    //         const payload = {
    //             id: "580127105174038",
    //             mobile: selectedContact?.waid,
    //             message: newMessage,
    //         };
    //         axios.post('https://emedha.com/echatbot/enotifier/client-message.php', payload)
    //             .then(response => {
    //                 console.log('Message sent successfully', response);
    //             })
    //             .catch(error => {
    //                 console.error('Error sending message:', error);
    //             });
    //         setNewMessage('');
    //     }
    // };

    const uniqueContacts = contacts.filter((contact, index, self) =>
        index === self.findIndex((t) => t.waid === contact.waid)
    );

    const handleShowOptions = () => {
        setShowOptions((prev) => !prev);
    };

    const handleOptionSelect = (option) => {
        alert(`Selected option: ${option}`);
        setShowOptions(false);
    };

    const formatDate = (date) => {
        const parsedDate = new Date(date);
        if (isNaN(parsedDate)) {
            return 'Invalid Date';
        }
        return format(parsedDate, 'MMMM dd, yyyy');
    };

    return (
        <div style={{ display: 'flex', height: '580px', fontFamily: 'Arial, sans-serif',fontSize:'12px' }}>
            <div style={{ width: '25%', borderRight: '1px solid #ccc', backgroundColor: '#f0f0f0', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', overflowY: 'auto' }}>
                {uniqueContacts.map((contact, index) => (
                    <div key={index} style={{ padding: '10px', cursor: 'pointer', width: '100%', ...(selectedContact?.waid === contact.waid ? { backgroundColor: '#dcf8c6' } : {}) }} onClick={() => handleSelectContact(contact)}>
                        {contact.waid}
                    </div>
                ))}
            </div>

            <div style={{ width: '75%', display: 'flex', flexDirection: 'column', borderLeft: '1px solid #ccc', backgroundColor: '#fff' }}>
                <div style={{ backgroundColor: '#075e54', color: 'white', padding: '10px', textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>
                    <h4>Chat with {selectedContact ? selectedContact.waid : ''}</h4>
                </div>

                <div style={{ flex: 1, padding: '10px', overflowY: 'auto' }}>
                    {messages.map((message, index) => {
                        const currentDate = formatDate(message.received_date);
                        const prevMessage = messages[index - 1];
                        const isSameDate = prevMessage && formatDate(prevMessage.received_date) === currentDate;

                        return (
                            <div key={index}>
                                {!isSameDate && (
                                    <div style={{ textAlign: 'center', fontSize: '12px', color: '#999', margin: '10px 0' }}>
                                        {currentDate}
                                    </div>
                                )}

                                <div style={{ padding: '10px', marginBottom: '10px', borderRadius: '10px', maxWidth: '70%', ...(message.sender === 'You' ? { backgroundColor: '#dcf8c6', alignSelf: 'flex-end' } : { backgroundColor: 'white', alignSelf: 'flex-start' }) }}>
                                    <span style={{ fontWeight: 'bold', marginRight: '5px' }}>{message.sender}:</span>
                                    <span style={{ fontSize: '14px' }}>{message.text}</span>

                                    {message.received_date && (
                                        <div style={{ fontSize: '12px', color: '#999', marginTop: '5px', textAlign: 'right' }}>
                                            {`Received ${formatDistanceToNow(new Date(message.received_date))} ago`}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div style={{ display: 'flex', padding: '10px', backgroundColor: 'white', borderTop: '1px solid #ccc' }}>
                    <button style={{ backgroundColor: '#075e54', color: 'white', border: 'none', borderRadius: '50%', padding: '8px', cursor: 'pointer', marginRight: '10px' }} onClick={handleShowOptions}>+</button>

                    {showOptions && (
                        <div style={{ position: 'absolute', bottom: '100px', backgroundColor: 'white', border: '1px solid #ccc', padding: '10px', zIndex: 1000 }}>
                            <div style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #ccc' }} onClick={() => handleOptionSelect('Document')}><FaFileAlt style={{ marginRight: '8px' }} />Document</div>
                            <div style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #ccc' }} onClick={() => handleOptionSelect('Photos & Videos')}><FaImage style={{ marginRight: '8px' }} />Photos & Videos</div>
                            <div style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #ccc' }} onClick={() => handleOptionSelect('Contacts')}><FaPhone style={{ marginRight: '8px' }} />Contacts </div>
                            <div style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #ccc' }} onClick={() => handleOptionSelect('Poll')}><FaPoll style={{ marginRight: '8px' }} />Poll</div>
                        </div>
                    )}

                    <input type="text" value={newMessage} onChange={(e) => setNewMessage(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSendMessage(); } }} placeholder="Type a message" style={{ flex: 1, padding: '10px', border: '1px solid #ccc', borderRadius: '20px', fontSize: '14px' }} />
                    <button onClick={handleSendMessage} style={{ backgroundColor: '#075e54', color: 'white', border: 'none', borderRadius: '20px', padding: '10px 15px', marginLeft: '10px', cursor: 'pointer' }}> Send</button>
                </div>
            </div>
        </div>
    );
};

export default MessagePanel;
